import React, { PropTypes } from 'react';
import moment from 'moment';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import AccessibleDatePicker from '@bibliocommons/base-accessibility-date-picker';
import { TextButton } from '@bibliocommons/base-buttons';
import { CalendarEmpty } from '@bibliocommons/base-icons';
import ShortFormattedDate from '../../../shared/ShortFormattedDate';
import ImmutablePropTypes from 'react-immutable-proptypes';

import './HoldsPauseDateLink.scss';


export default class HoldsPauseDateLink extends BcReactComponent {
  constructor(props) {
    super(props);
    this.state = {
      openPauseDateOverlay: false,
      date: this.getPauseEndDate()
    };
    this.bindAll('handleDate', 'handleClose');
  }

  getPauseEndDate() {
    return this.props.item.get('suspendEndDate');
  }

  componentWillUpdate(nextProps) {
    if (nextProps.item.get('suspendEndDate') !== this.props.item.get('suspendEndDate')) {
      this.setState({ date: nextProps.item.get('suspendEndDate') });
    }

    return null;
  }

  handleDate(dateValue) {
    this.setState({
      date: dateValue
    });
    this.props.handleUpdatePauseEndDate(dateValue);
  }

  handleClose() {
    this.setState({
      openPauseDateOverlay: false
    });
  }

  render() {
    const canChangePauseUntilDate = this.props.item.get('actions').includes('updateSuspend');
    return (
      <div className="cp-holds-pause-date-link">
        {canChangePauseUntilDate ?
          <AccessibleDatePicker
            className="cp-holds-pause-date-link-date-picker"
            open={this.state.openPauseDateOverlay}
            onDateChange={this.handleDate}
            handleClose={this.handleClose}
            initialDate={this.props.item.get('suspendEndDate')}
            isOutsideRange={(day) => !day.isAfter(moment(), 'day')}
            fullScreen>
            <TextButton
              showLoadingText
              disabled={this.props.disabled}
              isLoading={this.props.isLoading}
              className="holds-pause-date-link-button"
              handleClick={() => this.setState({ openPauseDateOverlay: true })}>
              <CalendarEmpty />
              <ShortFormattedDate value={this.getPauseEndDate()} />
            </TextButton>
          </AccessibleDatePicker> : <ShortFormattedDate value={this.state.date} />
      }
      </div>
    );
  }
}

HoldsPauseDateLink.propTypes = {
  item: ImmutablePropTypes.map,
  handleUpdatePauseEndDate: PropTypes.func,
  isLoading: PropTypes.bool,
  disabled: PropTypes.bool
};



// WEBPACK FOOTER //
// ./app/components/borrowing/holds/HoldsPauseDateLink/HoldsPauseDateLink.jsx